import { getPasswordStrength, PasswordStrength } from '@/slw/shared/lib/password-strength';

const strengthMap: Record<PasswordStrength, { color: string; bg: string; width: string; label: string }> = {
  weak: { color: '#ef4444', bg: '#fee2e2', width: '25%', label: 'Weak' }, // red-500, red-100
  medium: { color: '#eab308', bg: '#fef3c6', width: '75%', label: 'Medium' }, // yellow-500, yellow-100
  strong: { color: '#22c55e', bg: '#dcfce7', width: '100%', label: 'Strong' }, // green-500, green-100
};

export function PasswordStrengthBar({ password }: { password: string }) {
  const strength = getPasswordStrength(password);
  const { color, bg, width, label } = strengthMap[strength];

  return (
    <div className='flex items-center gap-8'>
      <div className='text-sm font-normal'>
        Password strength:{' '}
        <span className='font-medium' style={{ color }}>
          {label}
        </span>
      </div>
      <div className='h-2.5 rounded-sm flex-1' style={{ background: bg }}>
        <div
          className='h-full rounded-sm'
          style={{
            background: color,
            width,
            transition: 'width 150ms ease-in-out',
          }}
        />
      </div>
    </div>
  );
}
